var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ContextMenu',{attrs:{"options":_vm.options},on:{"select":function($event){!_vm.isDisabled && _vm.$emit('select', $event)}}},[_c('div',{staticClass:"dropdown",class:{ 'm-disabled': _vm.isDisabled }},[_vm._v(" "+_vm._s(_vm.selectedName)+" "),_c('Icon',{attrs:{"name":"chevron-down","color":"secondary-500"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }